/**
 * Created by commyfeng on 2017/3/17.
 */

import Coa from '@tencent/Coa/index';
import RequestError from '@tencent/Coa/lib/RequestError';
import RequestErrorType from '@tencent/Coa/lib/RequestErrorType';
import { getUrlParam } from '@tencent/vft-common/util';
var baseUrl = '//activity.video.qq.com/fcgi-bin/asyn_activity?otype=json&type=34';
var filterRet0 = Coa.filterResponse(function (res) {
  if (typeof res.ret !== 'undefined' && res.ret !== 0) {
    throw new RequestError(res.ret, res.msg, res, RequestErrorType.SYSTEM_ERR);
  }
  return res;
});
export function receive(actId, actKey, moduleId, channelId, ip, platform) {
  return Coa(filterRet0).run(baseUrl, {
    version: 1,
    act_id: actId,
    moduleId: moduleId,
    channelId: channelId,
    actKey: actKey,
    ip: ip,
    platform: platform
  });
}
export function magicReceiveNew(actId, modId) {
  return Coa(filterRet0).run(baseUrl, {
    version: 1,
    act_id: actId,
    module_id: modId,
    type: '100160',
    option: '100',
    is_prepublish: getUrlParam('is_prepublish') || '0'
  });
}
export function getWelfareInfo(actId) {
  return Coa(filterRet0).run('//vip.video.qq.com/fcgi-bin/comm_cgi?name=get_welfare_info&otype=json', {
    act_id: actId
  });
}